module.exports = __webpack_public_path__ + "static/media/bs4.348ab36c.webp";